<template>
  <section class="app-prices">
    <integration-steps :current-step="3" />

    <alert-discount />

    <article class="app-prices__wrapper">
      <dr-loader
        v-if="ui.isLoadingOffices"
        size="lg"
        class="app-prices__loader"
      />

      <div
        v-for="(office, index) in offices"
        :key="`app-integration-office-${index}`"
        :class="office.isTelemedicine && 'app-prices__office--telemedicine'"
        class="app-prices__office"
      >
        <div class="app-prices__office-header">
          <div class="app-prices__office-header-col">
            <dr-icon
              :key="`office-icon-price-${index}`"
              :name="office.isTelemedicine ? 'telemedicineOffice' : 'inpersonOffice'"
              fill="white"
              class="app-prices__office-header-icon"
            />

            <h6 class="app-prices__office-name">
              {{ office.isTelemedicine ? 'Telemedicina' : office.name }}
            </h6>
          </div>

          <div class="app-prices__office-header-col">
            <div
              :class="!office.isCollapsed && `app-prices__office-collapse--reverse`"
              class="app-prices__office-collapse"
              @click="office.isCollapsed = !office.isCollapsed"
            >
              <span v-if="!office.isCollapsed">fechar</span>
              <span v-if="office.isCollapsed">abrir</span>

              <span>
                <i class="icon icon-arrow-down" />
              </span>
            </div>
          </div>
        </div>

        <transition name="fade">
          <div
            v-show="!office.isCollapsed"
            class="app-prices__office-body"
          >
            <div class="app-prices__office-price">
              <div class="app-prices__office-price-col">
                <dr-icon
                  :name="office.isTelemedicine ? 'telemedicineAppointment' : 'inpersonAppointment'"
                  :color="office.isTelemedicine ? 'gradient' : 'transparent'"
                  :fill="office.isTelemedicine && 'gradient'"
                  class="app-prices__office-price-icon"
                />

                <span v-if="office.isTelemedicine">
                  Consulta telemedicina (preço particular)
                </span>

                <span v-else>
                  Consulta presencial (preço particular)
                </span>
              </div>

              <div class="app-prices__office-price-col">
                <div
                  class="app-prices__office-price-val"
                  :class="office.isEditPrice && 'app-prices__office-price-val--edit'"
                >
                  R$
                  <input
                    v-model="office.price.value.converted"
                    :ref="`office-price-value-${index}`"
                    type="text"
                    class="app-prices__office-price-input"
                    size="5"
                    @keypress="fn_FORMAT_CURRENCY($event, office.price.value)"
                    @keydown="fn_FORMAT_CURRENCY($event, office.price.value)"
                    @keyup.enter="
                      editAppointmentValue(office, index);
                      $event.target.blur();
                    "
                  />
                </div>

                <div class="app-prices__office-price-actions">
                  <div @click.prevent="actionModal.show = true">
                    <dr-icon
                      name="info"
                      color="silver"
                      class="app-prices__office-price-actions--icon"
                    />
                  </div>

                  <div @click="editAppointmentValue(office, index)">
                    <dr-icon
                      v-if="!office.isEditPrice"
                      name="edit"
                      color="gray"
                      class="app-prices__office-price-actions--icon app-prices__office-price-actions--icon-reverse"
                    />

                    <dr-icon
                      v-if="office.isEditPrice"
                      name="widgetTick"
                      color="rgb(86, 189, 210)"
                      class="app-prices__office-price-actions--icon"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="app-prices__office-wrapper">
              <div class="app-prices__office-wrapper-col">
                <p
                  v-if="office.isTelemedicine"
                  class="app-prices__office-wrapper-txt"
                >
                  Qual o tempo de consulta para atendimento online?
                </p>

                <div
                  v-if="office.isTelemedicine"
                  v-click-outside="() => ui.showTelemedicineDurations = false"
                  :class="ui.showTelemedicineDurations && 'weekday-interval__select--active'"
                  class="weekday-interval__select weekday-interval__select--hour app-prices__office-telemedicine-durations"
                >
                  <div
                    :class="ui.showTelemedicineDurations && 'weekday-interval__pick--open'"
                    class="weekday-interval__pick"
                    @click="
                      ui.showTelemedicineDurations = !ui.showTelemedicineDurations;
                      scrollToOption(
                        `select-telemedicine-duration`,
                        `select-telemedicine-duration-item-${
                          telemedicineDurations
                            .findIndex(d => d.duration === office['appointment_interval'])
                        }`,
                        ui.showTelemedicineDurations
                      )
                    "
                  >
                    <span>
                      {{
                        telemedicineDurations
                          .find(d => d.duration === office['appointment_interval'])
                          .label
                      }}
                    </span>
                    <i class="icon icon-arrow-down" />
                  </div>

                  <ul
                    v-if="ui.showTelemedicineDurations"
                    id="select-telemedicine-duration"
                    class="weekday-interval__select-list"
                  >
                    <li
                      v-for="(duration, index) in telemedicineDurations"
                      :key="`select-telemedicine-duration-${index}`"
                      :id="`select-telemedicine-duration-item-${index}`"
                      :class="
                        (telemedicineDurations.findIndex(d => d.duration === office['appointment_interval']) === index) &&
                        'weekday-interval__select-item--selected'
                      "
                      class="weekday-interval__select-item"
                      @click="
                        office['appointment_interval'] = duration.duration;
                        ui.showTelemedicineDurations = false;
                      "
                    >
                      {{ duration.label }}
                    </li>
                  </ul>
                </div>

                <p class="app-prices__office-wrapper-txt">
                  Selecione os dias da semana para atendimento
                  {{ office.isTelemedicine ? 'online' : 'presencial' }} do Dr. Conecta
                </p>

                <ul class="app-prices__weekdays">
                  <li
                    v-for="(day, index) in weekdays"
                    :key="`app-prices-weekday-${index}`"
                    :class="office.weekdays.includes(index) && 'app-prices__weekdays-day--selected'"
                    class="app-prices__weekdays-day"
                    @click="
                      checkOption(index, office.weekdays, office);
                      watchOfficeIntervals(office);
                    "
                  >
                    <span>{{ fn_IS_MOBILE() ? day.slice(0, 3) : day }}</span>
                  </li>
                </ul>
              </div>

              <div class="app-prices__office-wrapper-col">
                <p class="app-prices__office-wrapper-txt">
                  Qual o horário de atendimento para este consultório?
                </p>

                <transition name="fade">
                  <office-weekday-interval
                    v-if="!office.isCustomIntervals"
                    :ref="`office-intervals-general-${index}`"
                    :duration="appointmentDurationToMinutes(office['appointment_interval'])"
                    :initial-intervals="office.initialIntervalsDefault"
                    @set-intervals="($event) => {
                      office.nonCustomIntervals = $event;
                      watchOfficeIntervals(office);
                    }"
                  />
                </transition>

                <dr-switch
                  v-model="office.isCustomIntervals"
                  :id="`office-custom-interval-${index}`"
                  label-checked="Quero configurar horários diferentes para cada dia de semana"
                  label-unchecked="Quero configurar horários diferentes para cada dia de semana"
                  :class="(office.weekdays.length === 0) && 'app-prices__office-custom-interval--disabled'"
                  class="app-prices__office-custom-interval"
                  @change="watchOfficeIntervals(office)"
                />

                <transition-group
                  v-if="office.isCustomIntervals"
                  name="fade"
                >
                  <div
                    v-for="day in office.weekdays"
                    :key="`office-weekday-${day}-interval`"
                    class="app-prices__office-weekday-interval"
                  >
                    <span class="app-prices__office-title">{{ weekdays[day] }}</span>

                    <office-weekday-interval
                      :ref="`office-intervals-custom-${day}`"
                      :duration="appointmentDurationToMinutes(office['appointment_interval'])"
                      :initial-intervals="
                        office.initialIntervalsCustom
                          .find(d => parseInt(d.day) === parseInt(day))
                          .intervals
                      "
                      @set-intervals="
                        setOfficeIntervals($event, office, day);
                        watchOfficeIntervals(office);
                      "
                    />
                  </div>
                </transition-group>
              </div>
            </div>

            <div
              v-if="offices.length > 1"
              class="app-prices__office-footer"
            >
              <button
                class="btn app-integration__revoke-btn"
                @click="removeOffice(index)"
              >
                Remover consultório
              </button>
            </div>
          </div>
        </transition>
      </div>
    </article>

    <footer class="app-integration__footer">
      <p class="app-presentation__text">
        Os horários definidos para o Marketplace não afetam
        a sua agenda particular e ou do plano de saúde.
      </p>

      <p class="app-presentation__text">
        O sistema automaticamente verifica a disponibilidade dos
        horários livres para exibir no Marketplace Dr. Conecta.
      </p>

      <button
        :disabled="isDisabled || ui.isLoading"
        class="btn btn-primary app-integration__submit"
        @click="confirmSave()"
      >
        <span v-if="!ui.isLoading">Próximo</span>
        <dr-loader v-else size="sm" color="white" />
      </button>
    </footer>

    <action-modal
      v-if="actionModal.show"
      :active="actionModal.show"
      :css="actionModal.css"
      :body="actionModal.body"
      :size="actionModal.size"
      :btn="actionModal.btn"
      :action="actionModal.action"
      @close="actionModal.show = false"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import actionModal from '@/components/modals/action'
import officeWeekdayInterval from './weekdayInterval'
import integrationSteps from './integrationSteps'
import DrSwitch from '@/components/form/switch'
import alertDiscount from '@/components/layout/plans/alertDiscount.vue'
import EventBus from '@/globals/eventBus'

export default {
  name: 'AppIntegrationPrices',

  components: {
    integrationSteps,
    officeWeekdayInterval,
    actionModal,
    alertDiscount,
    DrSwitch
  },

  props: {
    doctor: {
      type: Object,
      required: true,
      default: () => {}
    },

    chosenOffices: {
      type: Array,
      required: false,
      default: () => []
    },

    isTelemedicine: {
      type: Boolean,
      required: false,
      default: null
    }
  },

  data () {
    return {
      offices: [],
      weekdays: null,
      weekdaysNames: null,
      telemedicineDurations: null,
      maxPrices: {
        facetoface: null,
        telemedicine: null
      },
      defaultPrices: {
        facetoface: null,
        telemedicine: null
      },
      defaultIntervals: [
        {
          start: { hour: 8, minute: 0 },
          end: { hour: 12, minute: 0 }
        },
        {
          start: { hour: 13, minute: 0 },
          end: { hour: 18, minute: 0 }
        }
      ],
      ui: {
        showTelemedicineDurations: false,
        showInfoModal: false,
        isLoading: false,
        isLoadingOffices: false
      },
      actionModal: {
        show: false,
        size: 'md4',
        css: `
          background: url(/static/img/modal-precos.png);
          background-size: cover;
          background-position: right center;
          color: white !important;
          max-width: 800px;
          width: 800px;
          `,
        btn: {
          class: 'btn-navy btn-sm float-right',
          text: 'Fechar'
        },
        body: `
          <div style="width: 420px;">
            <h2 style="font-size: 1.125rem; color: #227EF4; font-weight: 600;">
              Os preços exibidos em sua agenda online serão acrescidos da nossa taxa de serviço.
            </h2>

            <p style="font-weight: 600; font-size: 0.8rem; color: white; margin-top: 0; padding-top: 0; line-height: 1.8">
              O paciente conta com toda conveniência na marcação de consultas e pagamento online
              já integrado com sua agenda.
              <br>
              Não realizamos nenhum abatimento no seu valor de consulta
              cadastrado no sistema, desta forma conseguimos cobrir as despesas de toda infraestrutura
              de tecnologia, cartão de crédito e antifraude sem custo para você.
            </p>

            <p style="font-weight: 600; padding-bottom: 0; margin-bottom: 0;">
              <h2 style="font-size: 1.125rem; color: #227EF4; font-weight: 600;">
                Valores da taxa de serviço:
              </h2>

              <ul style="font-size: 0.8rem; font-weight: 600">
                <li>Consultas até R$ 300,00 será acrescido 10%</li>
                <li>Consultas até R$ 300,01 até R$ 600,00 será acrescido 8%</li>
                <li>Consultas até R$ 600,01 será acrescido 6%</li>
              </ul>
            </p>
          </div>
        `,
        action: function () {
          this.close()
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      appIntegration: 'getAppIntegration',
      plan: 'getPlan'
    }),

    integratedOffices () {
      return this.appIntegration['doctor_offices']
    },

    localOffices () {
      const whichIntegratedOffices = this.hasTelemedicine
        ? [...this.integratedOffices]
        : [...this.integratedOffices.filter(office => office.type !== 'TELEMEDICINE')]

      return this.chosenOffices && this.chosenOffices.length > 0
        ? this.chosenOffices
        : whichIntegratedOffices
    },

    isDisabled () {
      return this.offices.some(office => !office.weekdays.length)
    },

    hasTelemedicine () {
      return this.isTelemedicine !== null
        ? !!this.isTelemedicine
        : this.integratedOffices.some(office => office.type === 'TELEMEDICINE')
    },

    hasPreviousTelemedicine () {
      if (this.doctor['doctor_offices']) {
        const id = this.doctor['doctor_offices']
          .find(office => /telemedicine/gi.test(office.type))

        return id ? id.id : false
      }

      return false
    }
  },

  created () {
    this.fn_HIDE_PROGRESS()
  },

  mounted () {
    this.ui.isLoadingOffices = true
    this.fn_SHOW_PROGRESS()

    this.getConfigurationParameters()
      .then(res => this.setPrices(res.data))
      .then(this.setTelemedicineIntervals)
      .then(() => {
        const quantity = this.localOffices
          .filter(office => office.type !== 'TELEMEDICINE')
          .length
        const tempOffices = []

        for (let i = 0; i < quantity; i += 1) {
          tempOffices.push(this.createOfficeObject())
        }

        if (this.hasTelemedicine) {
          tempOffices.push(this.createOfficeObject('online'))
        }

        return tempOffices
      })
      .then(tempOffices => this.loadSavedData(tempOffices))
      .then(offices => (this.offices = offices))
      .catch(err => console.log(err))
      .finally(() => {
        if (this.offices.length === 0) {
          this.$router.push({ name: 'DoctorAppIntegrationOffices' })
          return
        }

        // if (this.plan.isPro) {
        //   this.removeTelemedicineOffice()
        // }

        this.ui.isLoadingOffices = false
        this.fn_HIDE_PROGRESS()
      })

    this.weekdays = this.$moment
      .weekdays()
      .map(day => day.replace('-feira', ''))

    this.weekdaysNames = [0, 1, 2, 3, 4, 5, 6]
      .map(day => this.$moment().locale('en-us').weekday(day).format('dddd'))
  },

  methods: {
    appointmentDurationToMinutes (duration) {
      const durationDate = new Date(duration)
      const minutes = (durationDate.getHours() * 60) + durationDate.getMinutes()

      return minutes
    },

    appointmentMinutesToDuration (minutes) {
      const h = parseInt(minutes / 60)
      const m = minutes % 60

      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
    },

    checkOption (item, list, office = null) {
      if (list.includes(item)) {
        list.splice(list.indexOf(item), 1)

        if (office && office.isCustomIntervals) {
          const index = office.initialIntervalsCustom
            .findIndex(i => i.day === item) || false
          index && office.initialIntervalsCustom.splice(index, 1)
        }
      } else {
        list.push(item)

        if (office && office.isCustomIntervals) {
          office.initialIntervalsCustom
            .push({ day: item, intervals: [...this.defaultIntervals] })
        }
      }

      list.sort()
    },

    watchOfficeIntervals (office) {
      office.intervals = null

      if (office.isCustomIntervals) {
        office.intervals = office.customIntervals
        office.initialIntervalsCustom = []

        office.weekdays.forEach((day) => {
          office.initialIntervalsCustom
            .push({ day, intervals: [...this.defaultIntervals] })
        })
      } else {
        office.intervals = office.weekdays
          .map((day) => {
            return {
              dayOfWeek: this.weekdaysNames[day],
              exclusivePeriodAgendas: office.nonCustomIntervals
            }
          })
      }

      // remove exceding office intervals
      const weekdays = office.weekdays.map((i) => this.weekdaysNames[i])
      const newIntervals = []

      weekdays.forEach((weekday) => {
        const period = office.intervals.find((item) => item.dayOfWeek === weekday)

        if (period) {
          newIntervals.push(
            JSON.parse(JSON.stringify(period)))
        }
      })

      office.intervals = JSON.parse(JSON.stringify(newIntervals))
      office.customIntervals = JSON.parse(JSON.stringify(newIntervals))
    },

    setOfficeIntervals (intervals, office, day) {
      const dayObj = {
        dayOfWeek: this.weekdaysNames[day],
        exclusivePeriodAgendas: intervals
      }
      const index = office.customIntervals
        .findIndex(i => ('dayOfWeek' in i) && (i.dayOfWeek === this.weekdaysNames[day]))

      if (index >= 0) {
        office.customIntervals[index] = dayObj
      } else {
        office.customIntervals.push(dayObj)
      }
    },

    scrollToOption (where, to, isOpen = false) {
      if (isOpen) {
        this.$nextTick(() => {
          const list = document.querySelector(`#${where}`)
          const item = document.querySelector(`#${to}`)

          list.scrollTop = item.offsetTop
        })
      }
    },

    editAppointmentValue (office, index) {
      if (this.fn_IS_DOCTOR_FACILITIES() || !!1 === true) {
        office.isEditPrice = !office.isEditPrice
        office.isEditPrice && this.$refs[`office-price-value-${index}`][0].focus()
      } else {
        // mostrar modal
      }
    },

    getRemovedOffices () {
      const oldOffices = [...this.integratedOffices].map(i => i.id)
      const newOffices = [...this.offices].map(i => i.id)

      newOffices.forEach((officeId) => {
        if (oldOffices.includes(officeId)) {
          const index = oldOffices.findIndex(item => item === officeId)
          oldOffices.splice(index, 1)
        }
      })

      return [...this.integratedOffices].filter(office => oldOffices.includes(office.id))
    },

    deleteOffices (offices) {
      const promises = []

      offices.forEach((item) => {
        promises.push(() => {
          return this.$http
            .delete(
              `doctor/app_integration/doctor_office/${item.id}`,
              this.$store.getters.getAuthHeader
            )
        })
      })

      return new Promise((resolve, reject) => {
        promises.forEach(promise => promise())

        Promise.all(promises)
          .then(resolve)
          .catch(reject)
      })
    },

    confirmSave () {
      if (
        this.integratedOffices.length > 0 &&
        this.getRemovedOffices().length > 0
      ) {
        const deleteOffices = this.getRemovedOffices().map((item) => {
          const { id, name } = item
          return { id, name }
        })

        let ul = '<ul>'
        deleteOffices.forEach((office) => (ul = `${ul}<li><strong>${office.name}</strong></li>`))
        ul = `${ul}</ul>`

        this.$store.dispatch('setModalConfirm', {
          title: 'Confirmação',
          body: `Deseja prosseguir? Ao confirmar, os
            consultórios abaixo serão removidos da Integração.
            ${ul}
          `,
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          beforeClose: (v) => {
            if (v) {
              this.deleteOffices(deleteOffices)
                .then(this.save)
            }

            this.$store.dispatch('setModalConfirm')
          },
          size: 'md',
          active: true
        })

        return
      }

      this.save()
    },

    save () {
      const promises = []

      const validatePrices = this.offices
        .find((office) => {
          if (office.isTelemedicine && office.price.value.raw > this.maxPrices.telemedicine) {
            return true
          }

          if (!office.isTelemedicine && office.price.value.raw > this.maxPrices.facetoface) {
            return true
          }

          return false
        }) || null

      if (validatePrices) {
        let msg = validatePrices.isTelemedicine
          ? `O preço das consultas de telemedicina não pode ser superior a R$ ${
            this.$options.filters.TO_BRL(this.maxPrices.telemedicine)
          }.`
          : `O preço das consultas presenciais Dr. Conecta não pode ser superior a R$ ${
            this.$options.filters.TO_BRL(this.maxPrices.facetoface)
          }.`

        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: msg,
          size: 'md',
          active: true
        })

        return
      }

      this.offices.forEach((office) => {
        const headers = this.$store.getters.getAuthHeader.headers

        const prefix = (!this.hasPreviousTelemedicine && office.isTelemedicine)
          ? 'telemedicine'
          : office.id || this.hasPreviousTelemedicine
        const url = `/doctor/app_integration/doctor_office/${prefix}`

        const method = (!this.hasPreviousTelemedicine && office.isTelemedicine)
          ? 'post'
          : 'put'

        const keyName = (method === 'post')
          ? 'telemedicine_doctor_office'
          : 'app_integration'

        const data = {
          [keyName]: {
            exclusiveDaysAgendas: [...office.intervals],
            specialtyPrice: office.price.value.raw
          }
        }

        if (office.isTelemedicine) {
          data[keyName].appointmentInterval = this.telemedicineDurations
            .find((d) => d.duration === office['appointment_interval'])
            .value
        }

        promises.push(this.$http({ url, method, data, headers }))
      })

      this.ui.isLoading = true
      this.fn_SHOW_PROGRESS()

      Promise.all(promises)
        .then(res => this.getAppIntegration())
        .then(() => this.fn_GET_DOCTOR())
        .then(doctor => EventBus.$emit('updated-user-data', doctor))
        .then(() => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Períodos e preços cadastrados com sucesso.',
            size: 'md',
            active: true
          })

          setTimeout(() => {
            this.$store.dispatch('setModalAlert')
            this.$router.push({ name: 'DoctorAppIntegrationFinance' })
          }, 2000)
        })
        .catch(err => this.handleError(err))
        .finally(() => {
          this.ui.isLoading = false
          this.fn_HIDE_PROGRESS()
        })
    },

    loadSavedData (chosenOffices) {
      const returnedOffices = []

      const telemedicineFirst = (a, b) => {
        if (
          (a.isTelemedicine && !b.isTelemedicine) ||
          (a.type === 'TELEMEDICINE' && b.type === 'FACETOFACE')
        ) {
          return -1
        }

        if (
          (!a.isTelemedicine && b.isTelemedicine) ||
          (a.type === 'FACETOFACE' && b.type === 'TELEMEDICINE')
        ) {
          return 1
        }

        return 0
      }
      let targetOffices = chosenOffices
        .map((item) => ({ ...item, hasSaved: false }))
        .sort(telemedicineFirst)

      const targetTelemedicine = { ...targetOffices.find(i => i.isTelemedicine) }
      const originTelemedicine = this.localOffices.some(i => i.type === 'TELEMEDICINE')
        ? { ...this.localOffices.find(i => i.type === 'TELEMEDICINE') }
        : null

      if (this.hasTelemedicine) {
        if (targetTelemedicine && originTelemedicine) {
          returnedOffices.push(this.saveFromObjectToObject(originTelemedicine, targetTelemedicine))
        } else {
          returnedOffices.push(targetTelemedicine)
        }
      }

      targetOffices = targetOffices.filter(i => !i.isTelemedicine)
      this.localOffices
        .filter(i => i.type === 'FACETOFACE')
        .forEach((office, index) => {
          const origin = { ...office }
          const target = targetOffices[index]

          returnedOffices.push({ ...this.saveFromObjectToObject(origin, target) })
        })

      return returnedOffices
    },

    saveFromObjectToObject (origin, target) {
      const hasIntegrated = this.integratedOffices.length > 0

      target.name = origin.name
      target.id = 'id' in origin ? origin.id : target.id
      target.price.value.raw = hasIntegrated
        ? parseFloat(origin['specialty_price'])
        : target.price.value.raw
      target.price.value.converted = hasIntegrated
        ? this.$options.filters.TO_BRL(parseFloat(origin['specialty_price']))
        : target.price.value.converted
      target['appointment_interval'] = hasIntegrated
        ? origin['appointment_interval']
        : target['appointment_interval']

      // Edge case: telemedicine appointment_interval is zero
      if (
        target.isTelemedicine &&
        !this.telemedicineDurations
          .map(duration => duration.duration)
          .includes(target['appointment_interval'])
      ) {
        target['appointment_interval'] = this.telemedicineDurations
          .find(duration => duration.label === '30min')
          .duration
      }

      if (origin['exclusive_days_agendas'].length > 0) {
        // set weekdays
        const savedWeekdays = {
          days: origin['exclusive_days_agendas']
            .map((day) => {
              return {
                dayOfWeek: day['day_of_week'],
                intervals: day['exclusive_period_agendas']
                  .map((d) => ({
                    periodStart: d['period_start'],
                    periodEnd: d['period_stop']
                  }))
              }
            })
        }

        // check if is custom intervals
        const areEqual = (obj1, obj2) => {
          if (
            obj1.periodStart === obj2.periodStart &&
            obj1.periodEnd === obj2.periodEnd
          ) {
            return true
          }

          return false
        }

        const savedIntervals = savedWeekdays.days.map(d => d.intervals)
        let isCustomIntervals = false

        for (let i = 0; i < savedIntervals.length - 1; i++) {
          if (savedIntervals[i].length === savedIntervals[i + 1].length) {
            for (let j = 0; j < savedIntervals[i].length; j++) {
              if (!areEqual(savedIntervals[i][j], savedIntervals[i + 1][j])) {
                isCustomIntervals = true
                break
              }
            }
          } else {
            isCustomIntervals = true
            break
          }
        }

        savedWeekdays['isCustomIntervals'] = isCustomIntervals

        // check days on layout
        savedWeekdays.days.forEach((day) => {
          const index = this.weekdaysNames.findIndex(d => d === day.dayOfWeek)
          this.checkOption(index, target.weekdays, target)
        })

        // set non custom interval
        if (!savedWeekdays.isCustomIntervals) {
          const nonCustomInterval = []
          for (
            let i = 0;
            i < savedWeekdays.days[0].intervals.length;
            i++
          ) {
            nonCustomInterval.push(
              {
                ...this.buildIntervalObject(
                  savedWeekdays.days[0].intervals[i].periodStart,
                  savedWeekdays.days[0].intervals[i].periodEnd
                )
              }
            )
          }

          this.$set(target, 'initialIntervalsDefault', nonCustomInterval)

          const customIntervals = []
          nonCustomInterval.forEach((interval) => {
            const periodStart = `${
              String(interval.start.hour).padStart(2, '0')
            }:${
              String(interval.start.minute).padStart(2, '0')
            }`

            const periodStop = `${
              String(interval.end.hour).padStart(2, '0')
            }:${
              String(interval.end.minute).padStart(2, '0')
            }`

            customIntervals.push({ periodStart, periodStop })
          })

          target.intervals = target.weekdays
            .map((day) => {
              return {
                dayOfWeek: this.weekdaysNames[day],
                exclusivePeriodAgendas: customIntervals
              }
            })

        // set custom interval
        } else {
          target.isCustomIntervals = savedWeekdays.isCustomIntervals
          target.initialIntervalsDefault = [...this.defaultIntervals]
          target.initialIntervalsCustom = []

          savedWeekdays.days.forEach((weekday) => {
            const intervals = []
            const day = this.weekdaysNames.findIndex(d => d === weekday.dayOfWeek)

            weekday.intervals.forEach((i) => {
              intervals.push({ ...this.buildIntervalObject(i.periodStart, i.periodEnd) })
            })

            target.initialIntervalsCustom.push({ day, intervals })
          })
        }

        this.$set(target, 'isCustomIntervals', isCustomIntervals)
      }

      return target
    },

    buildIntervalObject (start, end) {
      const momentStart = this.$moment(start)
      const momentEnd = this.$moment(end)

      return {
        start: {
          hour: parseInt(momentStart.format('H')),
          minute: parseInt(momentStart.format('m'))
        },
        end: {
          hour: parseInt(momentEnd.format('H')),
          minute: parseInt(momentEnd.format('m'))
        }
      }
    },

    getConfigurationParameters () {
      const url = '/configuration_parameters/medical_consultation_default_price'

      return this.$http.get(url, this.$store.getters.getAuthHeader)
    },

    getAppIntegration () {
      this.$http
        .get('/doctor/app_integration', this.$store.getters.getAuthHeader)
        .then(res => this.$store.dispatch('setAppIntegration', res.data['app_integration']))
    },

    findErrorMessage (object) {
      let errorMessage = null

      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }

      if (Array.isArray(object)) {
        object.forEach((element) => {
          if (typeof element === 'object') {
            recursiveSearch(element)
          } else {
            errorMessage = element
          }
        })
      } else {
        recursiveSearch(object)
      }

      return errorMessage
    },

    handleError (err) {
      const msg = (typeof err !== 'object')
        ? err
        : ('errors' in err)
          ? this.findErrorMessage(err.errors)
          : 'Ocorreu um erro.'

      this.$store.dispatch('setModalAlert', {
        title: 'Erro',
        body: Array.isArray(msg) ? msg[0] : msg,
        size: 'md',
        active: true
      })
    },

    setPrices (data) {
      this.defaultPrices.facetoface = parseFloat(
        data.find(i => /(facetoface).*?(default)/gi.test(i.name)).value
      )

      this.defaultPrices.telemedicine = parseFloat(
        data.find(i => /(telemedicine).*?(default)/gi.test(i.name)).value
      )

      this.maxPrices.facetoface = parseFloat(
        data.find(i => /(telemedicine).*?(max)/gi.test(i.name)).value
      )

      this.maxPrices.telemedicine = parseFloat(
        data.find(i => /(telemedicine).*?(max)/gi.test(i.name)).value
      )
    },

    setTelemedicineIntervals () {
      const utcOffset = `-0${(new Date().getTimezoneOffset()) / 60}00`

      this.telemedicineDurations = [
        {
          label: '15min',
          duration: '1970-01-01T00:15:00-03:00',
          value: '00:15'
          // duration: this.$moment(0)
          //   .utcOffset(utcOffset)
          //   .set({ hour: 0, minute: 15 })
          //   .toString()
        },
        {
          label: '30min',
          duration: '1970-01-01T00:30:00-03:00',
          value: '00:30'
          // duration: this.$moment(0)
          //   .utcOffset(utcOffset)
          //   .set({ hour: 0, minute: 30 })
          //   .toString()
        },
        {
          label: '45min',
          duration: '1970-01-01T00:45:00-03:00',
          value: '00:45'
          // duration: this.$moment(0)
          //   .utcOffset(utcOffset)
          //   .set({ hour: 0, minute: 45 })
          //   .toString()
        },
        {
          label: '1h',
          duration: '1970-01-01T01:00:00-03:00',
          value: '01:00'
          // duration: this.$moment(0)
          //   .utcOffset(utcOffset)
          //   .set({ hour: 1, minute: 0 })
          //   .toString()
        },
        {
          label: '1h30min',
          duration: '1970-01-01T01:30:00-03:00',
          value: '01:30'
          // duration: this.$moment(0)
          //   .utcOffset(utcOffset)
          //   .set({ hour: 1, minute: 30 })
          //   .toString()
        },
        {
          label: '2h',
          duration: '1970-01-01T02:00:00-03:00',
          value: '02:00'
          // duration: this.$moment(0)
          //   .utcOffset(utcOffset)
          //   .set({ hour: 2, minute: 0 })
          //   .toString()
        }
      ]
    },

    createOfficeObject (type = 'offline') {
      const offlineOffice = {
        isCustomIntervals: false,
        isCollapsed: false,
        isEditPrice: false,
        weekdays: [],
        intervals: [],
        customIntervals: [],
        nonCustomIntervals: [],
        isTelemedicine: false,
        price: {
          value: {
            raw: this.defaultPrices.facetoface,
            converted: this.$options.filters.TO_BRL(this.defaultPrices.facetoface)
          }
        },
        initialIntervalsCustom: null,
        initialIntervalsDefault: [...this.defaultIntervals]
      }

      const onlineOffice = {
        'appointment_interval': this.telemedicineDurations[1].duration,
        name: 'Telemedicina Dr. Conecta',
        type: 'TELEMEDICINE',
        isCustomIntervals: false,
        isCollapsed: false,
        isEditPrice: false,
        weekdays: [],
        intervals: [],
        customIntervals: [],
        nonCustomIntervals: [],
        isTelemedicine: true,
        price: {
          value: {
            raw: this.defaultPrices.telemedicine,
            converted: this.$options.filters.TO_BRL(this.defaultPrices.telemedicine)
          }
        },
        initialIntervalsCustom: null,
        initialIntervalsDefault: [...this.defaultIntervals],
        id: null
      }

      return type === 'offline'
        ? offlineOffice
        : onlineOffice
    },

    removeOffice (index = null) {
      if (index !== null) {
        this.$store.dispatch('setModalConfirm', {
          title: 'Confirmação',
          body: 'Tem certeza que deseja remover este consultório?',
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          beforeClose: (v) => {
            if (v) {
              this.offices.splice(index, 1)
            }

            this.$store.dispatch('setModalConfirm')
          },
          size: 'md',
          active: true
        })
      }
    },

    removeTelemedicineOffice () {
      const index = this.offices.findIndex((office) => office.isTelemedicine)
      this.offices.splice(index, 1)
    }
  }
}
</script>
